
import LoginForm from '@web/components/LoginForm.vue'

export default {
  name: 'Login',
  components: {
    LoginForm
  }
}
